import { render } from "./slide29.vue?vue&type=template&id=2e31fb6e&scoped=true"
import script from "./slide29.vue?vue&type=script&lang=js"
export * from "./slide29.vue?vue&type=script&lang=js"

import "./slide29.vue?vue&type=style&index=0&id=2e31fb6e&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e31fb6e"]])

export default __exports__